import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function useBrandColor() {
  // Brand color lives in Supabase org settings (migrated from Traccar attributes).
  // Fall back to server.attributes for legacy installs without Supabase.
  const brandColor = useSelector(
    (state) => state.org?.settings?.brandColor || state.session.server?.attributes?.brandColor
  );

  useEffect(() => {
    if (brandColor && /^#[0-9A-Fa-f]{6}$/.test(brandColor)) {
      document.documentElement.style.setProperty('--brand-dynamic', brandColor);
    } else {
      document.documentElement.style.removeProperty('--brand-dynamic');
    }
    return () => {
      document.documentElement.style.removeProperty('--brand-dynamic');
    };
  }, [brandColor]);
}
